<template>
    <v-card class="rounded-lg">
        <v-card-title>
            Account
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
            <v-alert type="info" color="primary">Coming soon. Contact us if you need help with your account.</v-alert>
        </v-card-text>
    </v-card>
</template>

<script>
import { useUserStore } from '../../stores/user'

export default {
    name: 'Account',
    created: function() {
        // this.app = useAppStore()
        this.user = useUserStore()
    },
    data: function() {
        return {
            app: null,
            user: null,
        }
    },
    mounted: function() {
        // this.loadProducts()
    },
    methods: {
        // loadRecordings: function() {
        //     this.loading = true
        //     this.user.app.get('meeting/recordings').then(response => {
        //         this.recordings = response.data.recordings
        //         this.loading = false
        //     })
        //     .catch(error => {
        //         console.error(error)
        //         this.loading = false
        //     })
        // }
        // loadProducts: function() {
        //     this.user.app.get('account/products')
        // }
    }
}
</script>
